import { getField, updateField } from 'vuex-map-fields';
import AxiosWrapper from '~/assets/javascript/AxiosWrapper';
import { translate } from '~/assets/javascript/localization/Localization';
const indexUrl = '/data_api/activity_logs'

AxiosWrapper.init();

const getDefaultState = () => ({
  is_initializing: true,
  loadingMessage: translate('no_data_available'),
  total_pages: 0,
  total: 0,
  params: {
    page: 1,
    items_per_page: 10
  },
  activityLogs: [],
  sortOrder: [
    {
      field: 'created_at',
      sortField: 'created_at',
      direction: 'desc'
    }
  ],
})

export const state = getDefaultState

export const getters = {
  getField
}

export const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  updateField,
  init(state, getRequestData) {
    ({
      activity_logs: state.activityLogs,
      total_pages: state.total_pages,
      total: state.total
    } = getRequestData);
  }
}

export const actions = {
  async init({ dispatch, commit }) {
    commit("resetState")

    dispatch('setStoreParamsWithUrlParams')
    dispatch('getPage');
  },
  setStoreParamsWithUrlParams({ commit, state }) {
    let mergedParams = { ...state.params, ...AxiosWrapper.getSearchParams() }

    commit('updateField', { path: "params", value: mergedParams });
  },
  async getPage({ commit, state }) {
    let params = state.params;

    let stringify = AxiosWrapper.buildPathWithSearchParams(params)
    history.replaceState(history.state, 'Activity Logs', stringify)

    AxiosWrapper.get(indexUrl, { params })
      .then(function (response) {
        commit('init', response.data)
        commit('updateField', {
          path: 'is_initializing',
          value: false
        });
      })
  },
  setPageAndThenGetPage({ dispatch, commit, state }, page) {
    //Not ideal.  If you find a better way let me know -LK.
    //If you remove the initialized params won't work.
    if (state.is_initializing == false) {
      commit('updateField', { path: "params.page", value: page });
      dispatch('getPage');
    }
  },
  changeNumberOfItemsPerPage({ commit, dispatch }, itemsPerPage) {
    commit('updateField', {
      path: 'params.items_per_page',
      value: itemsPerPage
    });
    dispatch('getPage');
  }
}